module.exports = __webpack_public_path__ + "static/media/navegador.d82b47e0.svg";